import { connect } from 'react-redux';
import CommandBar from './command_bar';
import { openPanel } from '../../actions/panel';
import {
  zoomIn, zoomOut, resetZoom, setSilhouette, hideSilhouette
} from '../../actions/canvas';
import { addCurrentWallToCart } from '../../actions/cart';
import { undo } from '../../actions/undo';
import { totalPrice } from '../../selectors/work_sizes';

const mapStateToProps = (state) => {
  const {
    canvas: {
      name, works, currency, pricing
    },
    panel: { info }
  } = state;
  return {
    name,
    currency,
    detailsVisible: !!info,
    // Server total already has the wall discounts subtracted; the client selector is
    // the fallback for the moment before the first save response lands.
    totalPrice: (pricing && typeof pricing.total === 'number') ? pricing.total : totalPrice(state),
    savedAmount: (pricing && pricing.discount) || 0,
    works,
    hasWorks: !!(works || []).length
  };
};

export default connect(mapStateToProps, {
  openPanel,
  zoomIn,
  zoomOut,
  resetZoom,
  undo,
  addCurrentWallToCart,
  setSilhouette,
  hideSilhouette
})(CommandBar);
